var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConeFilterActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9996 2H5.93563C4.86661 2 4 2.86661 4 3.93563V6.83908C4.00045 7.35227 4.20468 7.84427 4.56779 8.20692L9.16168 12.804V20.0659C9.16242 20.7366 9.51029 21.3591 10.0811 21.7112C10.6521 22.0639 11.365 22.0956 11.9651 21.7951L14.546 20.5046C15.2002 20.1765 15.6134 19.5074 15.6138 18.7755V12.804L18.4462 9.96967C17.7047 9.88797 17.0121 9.64414 16.4045 9.27442L13.6782 12.0008V18.7755L11.0973 20.0659V12.0008L5.93563 6.83908V3.93563H14.1135C14.2683 3.22164 14.5756 2.56449 14.9996 2Z",
    fill: "#A614B9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 4.5,
    r: 3.5,
    fill: "#12A963"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConeFilterActive);
export default __webpack_public_path__ + "static/media/cone-filter-active.df833b8e797a47528fac6ce77bfcb970.svg";
export { ForwardRef as ReactComponent };